<template>
  <div >
    <v-toolbar flat :dark="darkmode">
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            {{ name }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile
        v-for="(item, i) in items"
        :key="i"
        class="tile"
        :to="item.route"
      >
        <v-list-tile-action>
          <v-icon>{{item.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title >{{item.title}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      name: "Administrator",
      items: [
        { title: 'Dashboard', icon: 'dashboard', route: { name: 'admin.dashboard' } },
        { title: 'Students', icon: 'people_outline', route: { name: 'admin.students' } },
        { title: 'Guardians', icon: 'people', route: { name: 'admin.guardians' } },
        { title: 'Employees', icon: 'person', route: { name: 'admin.employees' } },
        { title: 'Classes', icon: 'border_all', route: { name: 'admin.classes' } },
        // { title: 'Fees Payment', icon: 'money', route: { name: 'admin.fees' } },
        { title: 'Financials', icon: 'money', route: { name: 'accountant.dashboard',params:{frmAdmin:true} } },
        { title: 'Bulk SMS', icon: 'speaker_notes', route: { name: 'admin.bulksms' } },
        { title: 'Settings', icon: 'settings', route: { name: 'admin.setts' } },
        { title: 'My Account', icon: 'account_box', route: { name: 'settings.profile' } }
      ]
    }
  },
   computed: {
    ...mapGetters({
      darkmode: "settings/DARKMODE",
    }),
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenus/Admin.vue